import React from 'react';
import ReactDOM from 'react-dom';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { size, getStyle, mobile } from 'styles';
import { TitleSecondary, Detail, Description } from './text';
import { ItemColumn, ItemRow } from './layout';

const Container = styled(ItemColumn)`
  position: relative;
  text-align: center;
  align-items: center;
  padding: ${size(4)};
  overflow-y: auto;
  width: ${getStyle('popupWidth')};
  max-height: ${getStyle('popupMaxHeight')};
  ${mobile(`
    max-height: ${getStyle('popupMaxHeightMobile')};
  `)};
`;

const Link = styled.a`
  color: ${getStyle('black')};
`;

const LinkContainer = styled(ItemRow)`
  justify-content: center;
`;

const Popup = ({ popupId, feature }) => {
  const popupEl = document.getElementById(popupId);
  if (!popupEl || !feature) return null;
  const {
    address,
    date,
    description,
    href,
    location,
    title,
  } = feature;
  return ReactDOM.createPortal(
    <Container sp={2}>
      <TitleSecondary>{title}</TitleSecondary>
      <Detail>{location}</Detail>
      <Detail>{date}</Detail>
      <Description>{description}</Description>
      <LinkContainer sp={1}>
        {href && (
          <>
            <Link
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Detail>More Info</Detail>
            </Link>
            <Detail>|</Detail>
          </>
        )}
        <Link
          href={`https://www.google.com/maps/place/${address}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Detail>Get Directions</Detail>
        </Link>
      </LinkContainer>
    </Container>,
    popupEl,
  );
};

Popup.propTypes = {
  feature: PropTypes.object,
  popupId: PropTypes.string,
};

Popup.defaultProps = {
  feature: null,
  popupId: null,
};

export default Popup;
